/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 26.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Classnames from 'classnames';
import axios from 'axios';
import querystring from 'querystring';
import Dropdown from 'react-dropdown';

import _get from 'lodash/get';

import DivLoader from '../../../../../components/DivLoader';
import Translate from '../../../../../components/Translate';

import {SetSettingsState} from '../../../../../actions/common/actions-common';

class RegistrationTab extends Component {
  locales = [
    {
      label: 'English',
      value: 'EN',
    },
    {
      label: 'Azərbaycan dili',
      value: 'AZ',
    },
    {
      label: 'Русский',
      value: 'RU',
    },
  ];
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isRegDone: false,
      needConfirmation: false,
      tabId: null,
      regId: null,
      formDataUser: '',
      formDataLocale: this.locales[0],
      formDataPassword: '',
      formDataPassword2: '',
      formDataFirstName: '',
      formDataLastName: '',
      formDataLanguage: '',
      formConfirmationCode: '',
    };
  }

  componentDidMount() {
    document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', function (e) {

      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }, true);
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.user.user !== this.props.user && this.props.user.user !== 'guest') {
      setTimeout(() => {

        this.props.SetSettingsState({
          isShown: false,
          tabId: null
        });
      }, 350);
    }

    if (this.state.isError && this.state.isError !== prevState.isError) {
      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }

    if (this.state.needConfirmation && this.state.needConfirmation !== prevState.needConfirmation) {
      document.getElementById('user_code') && document.getElementById('user_code').focus();
    }
  }

  _onUserChange = (event) => {

    this.setState({formDataUser: event.target.value});
  };

  _onLocaleSelect(locale) {

    this.setState({
      formDataLocale: locale,
    });
  }

  _onPasswordChange = (event) => {

    this.setState({formDataPassword: event.target.value});
  };


  _onPasswordChange2 = (event) => {

    this.setState({formDataPassword2: event.target.value});
  };


  _onFirstNameChange = (event) => {

    this.setState({formDataFirstName: event.target.value});
  };

  _onLastNameChange = (event) => {

    this.setState({formDataLastName: event.target.value});
  };

  _onConfirmationCodeChange = (event) => {

    this.setState({formConfirmationCode: event.target.value});
  };

  _onSubmitReg = (event) => {
    event.preventDefault && event.preventDefault();

    if (!this.state.formDataUser) {

      this.setState({
        isError: true,
        errorMsg: 'username field empty'
      });

      return;
    }

    if (!this.state.formDataPassword) {

      this.setState({
        isError: true,
        errorMsg: 'password field empty'
      });

      return;
    }

    if (this.state.formDataPassword !== this.state.formDataPassword2) {

      this.setState({
        isError: true,
        errorMsg: 'passwords mismatch'
      });

      return;
    }

    axios.post('api/nar/v1/registrations', { user: {
      password: this.state.formDataPassword,
      msisdn: this.state.formDataUser,
      language: this.state.formDataLocale.value,
    }}, {
      headers: {'X-Auth-Token': lh.common.config.get('authToken')},
    })
      .then((response) => {
        this.setState({
          needConfirmation: true,
          regId: _get(response, 'data.data.id'),
          isError: false,
          errorMsg: '',
        });
      })
      .catch((reason) => {
        this.setState({
          isError: true,
          errorMsg: _get(reason, 'response.data.error.message')
        });
      });
  };

  _onSubmitConfirm = (event) => {
    event.preventDefault && event.preventDefault();

    if (!this.state.formConfirmationCode) {

      this.setState({
        isError: true,
        errorMsg: 'code field empty'
      });

      return;
    }

    axios
      .post(`api/nar/v1/registrations/${this.state.regId}/commands/finish`,
        querystring.stringify({ code: this.state.formConfirmationCode }),
        {
          headers: {
            'X-Auth-Token': lh.common.config.get('authToken'),
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      )
      .then(() => {
        this.setState({
          isRegDone: true,
          needConfirmation: false,
          regId: null,
        });
      })
      .catch((reason) => {
        this.setState({
          isError: true,
          errorMsg: _get(reason, 'response.data.error.message')
        });
      });
  };

  _goToLogin = () => {

    this.props.SetSettingsState({
      isShown: true,
      tabId: 'login',
    });
  };

  render() {
    const { isError, errorMsg, inProgress, needConfirmation, isRegDone } = this.state;

    if (isRegDone) {

      return (<div className="settings-col">
        <p className="mt">
          <Translate content="settings.tabs.registration_confirm.success" />
        </p>
        <p style={{textAlign: 'center'}}>
          <a className="btn-dark" href="javascript:void(0)" onClick={this._goToLogin}>Sign In</a>
        </p>
      </div>);
    }

    const userLoginClass = Classnames({
      'error-field': isError && (errorMsg === 'already registered' || errorMsg === 'username field empty' || errorMsg === 'invalid subscriber nar msisdn'),
      'auth-field': true
    });

    const userPasswordClass = Classnames({
      'error-field': isError && errorMsg === 'password field empty',
      'auth-field': true
    });

    const userPassword2Class = Classnames({
      'error-field': isError && errorMsg === 'passwords mismatch',
      'auth-field': true
    });

    const userCodeClass = Classnames({
      'error-field': isError && (errorMsg === 'code field empty' || errorMsg === 'invalid registration code'),
      'auth-field': true
    });

    return (<div className="relative">
      <DivLoader loading={inProgress} />
      {!needConfirmation && <form id="regForm" className="js-form" role="form" onSubmit={this._onSubmitReg}>
        <div className="settings-col" style={{verticalAlign: 'top'}}>
          <label htmlFor="user_login_settings"> <Translate content="settings.tabs.registration.email" /> </label>
          <input id="user_login_settings" name="username" type="text" className={userLoginClass} tabIndex="1"
                 value={this.state.formDataUser} onChange={this._onUserChange} />
          <label htmlFor="user_password"> <Translate content="settings.tabs.registration.password" /> </label>
          <input id="user_password" name="password" type="password" className={userPasswordClass} tabIndex="2"
                 value={this.state.formDataPassword} onChange={this._onPasswordChange} />
          <label> <Translate content="settings.tabs.language.select_language" /> </label>
          <Dropdown options={this.locales} onChange={this._onLocaleSelect.bind(this)} value={{...this.state.formDataLocale}} placeholder="Select a language"/>
      </div>
        <div className="settings-col" style={{marginTop: '55px', verticalAlign: 'top'}}>
          <label htmlFor="user_password2"> <Translate content="settings.tabs.registration.password2" /> </label>
          <input id="user_password2" name="password2" type="password" className={userPassword2Class} tabIndex="3"
                 value={this.state.formDataPassword2} onChange={this._onPasswordChange2} />
          <a className="btn-dark authorization" href="javascript:void(0)" onClick={this._onSubmitReg} style={{marginTop: '55px', verticalAlign: 'top'}}> <Translate content="settings.tabs.registration.sign_up" /> </a>
        </div>
        <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="7" />
        <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="4">Continue</button>
      </form>}
      {needConfirmation && <form id="regForm" className="js-form" role="form" onSubmit={this._onSubmitConfirm}>
        <div className="settings-col" style={{marginTop: '55px', verticalAlign: 'top'}}>
          <label htmlFor="user_code"> <Translate content="settings.tabs.registration.code" /> </label>
          <input id="user_code" name="user_code" type="text" className={userCodeClass} tabIndex="3"
                 value={this.state.formConfirmationCode} onChange={this._onConfirmationCodeChange} />
          <a className="btn-dark authorization" href="javascript:void(0)" onClick={this._onSubmitConfirm}> <Translate content="settings.tabs.registration.sign_up" /> </a>
        </div>
        <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="7" />
        <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="4">Submit</button>
      </form>}
      {isError && <div className="reg-error-message" style={{position: 'absolute', top: '15px', right: '50px'}}>
        <em> <Translate content={`error.${errorMsg}`} /> </em>
      </div>}
    </div>);
  }
}

RegistrationTab.propTypes = {
  user: PropTypes.object,
  settings: PropTypes.object
};

const mapStateToProps = ({auth: {user}, common: {settings}}) => {

  return {user, settings};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({SetSettingsState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/_extentions/nar/nar-registration.js